import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfigService } from './api-config.service';
import { BrandGroup } from '../../models/brand-group.interface';

@Injectable({
  providedIn: 'root'
})
export class BrandGroupService {
  private get apiUrl(): string { return `${this.apiConfig.apiUrl}/brand-groups`; }

  constructor(private http: HttpClient, private apiConfig: ApiConfigService) {}

  getBrandGroups(brandSlug?: string): Observable<BrandGroup[]> {
    const params = brandSlug ? `?brandSlug=${brandSlug}` : '';
    return this.http.get<BrandGroup[]>(`${this.apiUrl}${params}`);
  }

  getBrandGroupById(id: string): Observable<BrandGroup> {
    return this.http.get<BrandGroup>(`${this.apiUrl}/${id}`);
  }

  createBrandGroup(group: Partial<BrandGroup>): Observable<BrandGroup> {
    return this.http.post<BrandGroup>(this.apiUrl, group);
  }

  updateBrandGroup(id: string, group: Partial<BrandGroup>): Observable<BrandGroup> {
    return this.http.put<BrandGroup>(`${this.apiUrl}/${id}`, group);
  }

  deleteBrandGroup(id: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}/${id}`);
  }
}
